const Percentage = 'Percent';
const DollarAmount = 'Dollar';
const FreeTrial = 'FreeTrial';

export const CouponDiscountType = {
  Percentage,
  DollarAmount,
  FreeTrial,
};

export const CouponDiscountTypes = Object.values(CouponDiscountType);
